import LotteryPage from "../views/lottery/LotteryPage.vue";
import LotteryRule from "../views/lottery/LotteryRule.vue";
import MyLucky from "../views/lottery/MyLucky.vue";
import PaseWinnersList from "../views/lottery/PastWinnersList.vue";
import LuckyCodesList from "../views/lottery/LuckyCodesList.vue";
import NewProduct from "../temporary/newproduct/NewProduct.vue";
// import ADKeyBoard from "../temporary/adkb/ADKeyBoard.vue";
// import Bilibili from "../temporary/bilibili/index.vue";
// import NewYear from "../temporary/newyear/index.vue";
// import AdjustTime from "../temporary/adjusttime/index.vue";
// import ClearCache from "../temporary/clearcache/index.vue";
// import TanabataIndex from "../temporary/tanabata/index/index.vue";
// import TanabataQuestion from "../temporary/tanabata/question/index.vue";
// import TanabataResult from "../temporary/tanabata/result/index.vue";
import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
// import { UserService } from "@/service/user.service";
const routes: Array<RouteRecordRaw> = [
  {
    path: "/lottery",
    name: "LotteryPage",
    component: LotteryPage,
    meta: {
      requireAuth: true
    }
  },
  // redirect : 重定向
  // children : 页面内子路由跳转
  // 规则
  {
    path: "/lottery/rule",
    name: "LotteryRule",
    redirect: "",
    component: LotteryRule,
    children: []
  },
  {
    path: "/my/lucky",
    name: "MyLucky",
    component: MyLucky
  },
  {
    path: "/pasewinners/list",
    name: "PaseWinnersList",
    component: PaseWinnersList
  },
  {
    path: "/luckycodes/list",
    name: "LuckyCodesList",
    component: LuckyCodesList
  },
  {
    path: "/news",
    name: "NewProduct",
    component: NewProduct
  },
  // {
  //   path: "/activity/adkeyboard",
  //   name: "ADKeyBoard",
  //   component: ADKeyBoard
  // },
  // {
  //   path: "/activity/bilibili",
  //   name: "Bilibili",
  //   component: Bilibili
  // },
  // {
  //   path: "/activity/newyear",
  //   name: "NewYear",
  //   component: NewYear
  // },
  // {
  //   path: "/adjust/time",
  //   name: "AdjustTime",
  //   component: AdjustTime
  // },
  // {
  //   path: "/clear/cache",
  //   name: "ClearCache",
  //   component: ClearCache
  // }
  // {
  //   path: "/activity/tanabata/index",
  //   name: "TanabataIndex",
  //   component: TanabataIndex
  // },
  // {
  //   path: "/activity/tanabata/question",
  //   name: "TanabataQuestion",
  //   component: TanabataQuestion
  // },
  // {
  //   path: "/activity/tanabata/result",
  //   name: "TanabataResult",
  //   component: TanabataResult
  // },
  // {
  //   path: "/clear/cache",
  //   name: "ClearCache",
  //   component: ClearCache
  // }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

router.beforeEach((to, from, next) => {
  next();
  // if (to.meta.requireAuth) {
  //   const user = new UserService(next);
  //   user.wxLoginCheck();
  //   if (!user.isLogin) {
  //     user.login();
  //   } else {
  //     next();
  //   }
  // } else {
  //   next();
  // }
});

export default router;
